import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { Globals } from '../globals';
import * as firebase from 'firebase/app';
import { FirestoreService } from './firestore/firestore.service';

interface Group {
    active: boolean;
    createdAt: any;
    description: any;
    name: string;
    updatedAt: any;
}

interface GroupId extends Group {
    id: string;
}

interface Permission {
    name: string;
    level: number;
    createAction: boolean;
    readAction: boolean;
    updateAction: boolean;
    deleteAction: boolean;
}

interface PermissionId extends Permission {
    id: string;
}

@Injectable()
export class GroupService {
    permissionCollection: any;
    permissions: any;

    collection: string;
    collectionUser: string;

    constructor(private afs: AngularFirestore, public afh: FirestoreService) {
        this.collection = Globals.GROUP_COLLECTION;
        this.collectionUser = Globals.USER_COLLECTION;
    }

    postGroup(groupObject: any) {
        let groupCollection = this.afs.collection(this.collection);

        return groupCollection.add(groupObject).then(function(docRef) {
            // console.log('Document added with ID: ', docRef.id);

            return docRef.id;
        }).catch(function(error) {
            // console.error('Error adding document: ', error);
            return '';
        });
    }

    getGroups() {
        let groupCollection = this.afs.collection(this.collection, ref => ref.where('active', '==', true).orderBy('name', 'asc'));

        let groups = groupCollection.snapshotChanges().map(actions => {
            console.log(actions);
            return actions.map(a => {
                const id$ = a.payload.doc.id;

                const data = a.payload.doc.data() as Group;

                const name = data.name;
                const description = data.description;

                return { id$, name, description };
            });
        }).map(object => object);

        return groups;
    }

    getGroup(id$: string) {
        let groupDocument = this.afs.doc(this.collection + '/' + id$);

        let group = groupDocument.valueChanges();

        return group.map(object => object);
    }

    putGroup(groupObject: any, id$: string) {
        let groupCollection = this.afs.collection(this.collection);

        return groupCollection.doc(id$).update(groupObject).then(function() {
            // console.log('Document updated');
        }).catch(function(error) {
            // console.error('Error updating document: ', error);
        });
    }

    /*
    // Method to delete the register from DB
    delGroup(id$: string) {
        this.groupDocument = this.afs.doc(this.collection + '/' + id$);

        return this.groupDocument .delete().then(function() {
            // console.log('Document deleted');
        }).catch(function(error) {
            // console.error('Error deleting document: ', error);
        });
    }
    */

    delGroup(id$: string) {
        if(!confirm('¿Desea eliminar?')) return;
        let groupCollection = this.afs.collection(this.collection);

        return groupCollection.doc(id$).update({ active: false, updatedAt: new Date() }).then(function() {
            // console.log('Document updated');
        }).catch(function(error) {
            // console.error('Error updating document: ', error);
        });
    }

    addPermission(groupId: string, id: string,  name: string){
        const col = this.afs.collection(`${this.collection}/${groupId}/permission`).doc(id);
        col.set(Globals.newPermission(name));
    }

    postPermissionAtomic(groupId: string) {
        const batch = firebase.firestore().batch();

        this.permissionCollection = firebase.firestore().collection(this.collection).doc(groupId).collection('permission');

        const permissions = {...Globals.PERMISSIONS_OBJ};

        for (let idP in permissions) {
            const permissionRef = this.permissionCollection.doc(idP);

            batch.set(permissionRef, permissions[idP]);
        }

        return batch.commit();
    }

    getPermissionCollection(groupId: string){
        return this.afh.colWithIds$(`${this.collection}/${groupId}/permission`);
    }

    getGroupPermission(groupId: string) {
        let groupDocument = this.afs.doc(this.collection + '/' + groupId);

        let group = groupDocument.snapshotChanges().map(action => {
            const id$ = action.payload.id;

            const data = action.payload.data() as Group;

            return { id$, ...data };
        }).map(document => {
            this.permissionCollection = this.afs.doc(this.collection + '/' + document.id$).collection('permission');

            const permissionRef: any = this.permissionCollection.snapshotChanges().map(actions => {
                return actions.map(a => {
                    const id$ = a.payload.doc.id;

                    const data = a.payload.doc.data() as Permission;

                    return { id$, ...data };
                });
            });

            return Observable.combineLatest(permissionRef, (permissionData) => {
                return {
                    permission: permissionData
                };
            }).map(data => {
                return {
                    permission: <any[]> data.permission,
                    ...document
                };
            });
        }).mergeMap(object => Observable.combineLatest(object));

        return group;
    }

    putGroupPermission(groupId: string, permissionId: string, actionObject: any){
        this.permissionCollection = this.afs.collection(this.collection).doc(groupId).collection('permission');

        return this.permissionCollection.doc(permissionId).update(actionObject).then(function() {
            // console.log('Document updated');
        }).catch(function(error) {
            // console.error('Error updating document: ', error);
        });
    }

    postGroupPermission(groupId: string, permissionId: string, actionObject: any){
        this.permissionCollection = this.afs.collection(this.collection).doc(groupId).collection('permission');

        return this.permissionCollection.doc(permissionId).set(actionObject).then(function() {
            // console.log('Document updated');
        }).catch(function(error) {
            // console.error('Error updating document: ', error);
        });
    }

}
